import "./StripeCheckoutPageHeader.scss";

import { Button, ChevronStartIcon, Flex, Text } from "@fluentui/react-northstar";
import React from "react";

import { useUserInfo } from "../../_shared/actions/useUserInfo";
import CyberMonday from "../../_shared/assets/cyber-monday.svg";
import CoreLogoWhite from "../../_shared/assets/polly-logo-with-text-white.svg";
import CoreLogo from "../../_shared/assets/polly-logo-with-text.svg";
import { useTeamsContext } from "../../_shared/state/TeamsContextProvider";

type StripePageType = "choose-plan" | "make-payment";
type props = {
  pageTitle: string;
  selectedPage: StripePageType;
  isDarkTheme: boolean;
  classForDarkTheme: string;
  navigateToPlansPage: () => void;
};
export const StripeCheckoutPageHeader: React.FC<props> = ({
  pageTitle,
  selectedPage,
  isDarkTheme,
  classForDarkTheme,
  navigateToPlansPage,
}) => {
  const { teamsContext } = useTeamsContext();
  const { user } = useUserInfo();

  return (
    <Flex column fill gap="gap.medium" className="checkout-page-header">
      {!teamsContext && (
        <Flex vAlign="end" gap="gap.small">
          <img src={isDarkTheme ? CoreLogoWhite : CoreLogo} height={35} alt="Polly" />
        </Flex>
      )}
      <Flex column fill hAlign="center" gap="gap.medium">
        <Flex
          fill
          column={selectedPage === "choose-plan" ? true : false}
          vAlign="center"
          hAlign="center"
          className="checkout-page-header__title-container"
          {...(selectedPage === "make-payment" && { space: "between" })}
        >
          {selectedPage === "make-payment" && (
            <Button
              text
              className="checkout-page-header__back-button"
              content={
                <Flex vAlign="center">
                  <ChevronStartIcon xSpacing="after" />
                  Back
                </Flex>
              }
              onClick={() => {
                navigateToPlansPage();
              }}
            />
          )}
          <Text
            content={pageTitle}
            className={`checkout-page-header__page-title${classForDarkTheme}`}
          />
          {user?.featureFlags?.cyberMonday2023 && selectedPage === "choose-plan" && (
            <Flex
              column
              vAlign="center"
              hAlign="center"
              gap="gap.small"
              className="checkout-page-header__cybermonday-container"
            >
              <img src={CyberMonday} alt="Polly Pending" width={90} />
              <div className={`checkout-page-header__cybermonday-text${classForDarkTheme}`}>
                💸️💥 <b>Cyber Monday Deal!</b> For a limited time, <b>get 30% off</b> when you
                upgrade! (discount applied at checkout)
              </div>
            </Flex>
          )}
          {selectedPage === "make-payment" && (
            <div className="checkout-page-header__empty-container"></div>
          )}
        </Flex>
      </Flex>
    </Flex>
  );
};
